
import './styles.scss';
import { SITE_URL } from '@/constants/constants';
import ProfileShimmer from '../../components/shimmers-screen/shimmer.vue';

const PhoneInput = () => import('../../components/phone-input/index.vue');

export default {
    name: 'ProfilePage',

    components: {
        'phone-input': PhoneInput,
        'profile-shimmer': ProfileShimmer  // Changed to match template usage
    },

    data() {
        return {
            loading: true,  // Add loading state
            role: '',
            group: '',

            menu: [
                {
                    detail: false,
                    button: true,
                    text: 'Profile',
                    url: '/account/profile'
                },
                {
                    detail: false,
                    button: true,
                    text: 'Buildings',
                    url: '/account/subscriptions'
                },
                {
                    detail: false,
                    button: true,
                    text: 'Sync',
                    url: '/account/storage-sync'
                },
                {
                    detail: false,
                    button: true,
                    text: 'Privacy Policy',
                    url: `${SITE_URL}/privacy-policy`
                }
            ],
            editing: false,
        }
    },

    methods: {
        toggleEdit() {
            if (this.editing) {
                this.saveChanges();
            }
            this.editing = !this.editing;
            
            // Focus on first input when entering edit mode
            if (this.editing) {
                this.$nextTick(() => {
                    if (this.$refs.firstNameInput) {
                        this.$refs.firstNameInput.setFocus();
                    }
                });
            }
        },

        async saveChanges() {
            console.log("user details", this.user);
            
            if (this.$store.state.online_status) {
                // Show loading indicator
                const loadingAlert = await this.$ionic.loadingController.create({
                    spinner: 'lines',
                    animated: true,
                    message: '',
                    translucent: false,
                });
                
                await loadingAlert.present();

                const userData = {
                    first_name: this.user.first_name,
                    last_name: this.user.last_name,
                    phone: this.user.phone,
                };

                this.$store
                    .dispatch("updateUserData", userData)
                    .then((response) => {
                        loadingAlert.dismiss();
                        this.$ionic.alertController
                            .create({
                                message: response || "User data updated successfully.",
                                buttons: ["OK"],
                            })
                            .then((a) => a.present());
                    })
                    .catch((error) => {
                        loadingAlert.dismiss();
                        this.$ionic.alertController
                            .create({
                                message: "Unable to update user data.",
                                buttons: ["OK"],
                            })
                            .then((a) => a.present());
                    });
            } else {
                this.$ionic.alertController
                    .create({
                        message: "Please establish an internet connection and try again.",
                        buttons: ["OK"],
                    })
                    .then((a) => a.present());
            }
        },

        confirmDeleteAccount() {
            this.$ionic.alertController
                .create({
                    header: 'Confirm Delete',
                    message: 'Are you sure you want to delete your account? This action cannot be undone.',
                    buttons: [
                        {
                            text: 'Cancel',
                            role: 'cancel',
                            cssClass: 'secondary',
                        },
                        {
                            text: 'Delete',
                            cssClass: 'danger',
                            handler: () => {
                                this.deleteAccount();
                            },
                        },
                    ],
                })
                .then((alert) => alert.present());
        },

        async deleteAccount() {
            if (this.$store.state.online_status) {
                const loadingAlert = await this.$ionic.loadingController.create({
                    spinner: 'lines',
                    animated: true,
                    message: 'Deleting account...',
                    translucent: false,
                });

                await loadingAlert.present();

                this.$store
                    .dispatch("deleteAccount")
                    .then((response) => {
                        loadingAlert.dismiss();
                        this.$ionic.alertController
                            .create({
                                message: response || "Account deleted successfully.",
                                buttons: [
                                    {
                                        text: 'OK',
                                        handler: () => {
                                            this.$store.dispatch('clearData').then(() => {
                                                this.$router.push({ path: '/' });
                                            });
                                        }
                                    }
                                ]
                            })
                            .then((a) => a.present());
                    })
                    .catch((error) => {
                        loadingAlert.dismiss();
                        this.$ionic.alertController
                            .create({
                                message: error || "Unable to delete account.",
                                buttons: ["OK"],
                            })
                            .then((a) => a.present());
                    });
            } else {
                this.$ionic.alertController
                    .create({
                        message: "Please establish an internet connection and try again.",
                        buttons: ["OK"],
                    })
                    .then((a) => a.present());
            }
        },

        loadUserData() {
            // Simulate initial loading
            // Since user data comes from Vuex store, we just need a short delay
            // to show the shimmer effect
            setTimeout(() => {
                this.loading = false;
            }, 800); // Adjust timing as needed
        },
    },

    computed: {
        user() {
            return this.$store.state.users.user;
        },

        readonly() {
            return !this.editing;
        },
    },

    created() {
        this.$store.commit('setMenuItems', this.menu);
        this.$store.commit('setMenuDetails', { title: 'Account', slug: 'account' });

        this.role = '{{ insert user role }}';
        this.group = '{{ insert user group }}';
    },

    mounted() {
        // Load user data and hide shimmer
        this.loadUserData();
    }
};